import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import Navbar from '@/components/home/Navbar';
import { ProjectReportWorkspace } from '@/components/project-self-evaluation-report';

const ProjectSelfEvaluationReportPage: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();

  if (!projectId) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        未找到项目ID
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <ProjectReportWorkspace projectId={projectId} />
      </Box>
    </Box>
  );
};

export default ProjectSelfEvaluationReportPage;
